/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetJobApplicationUsageStatisticsFromJSON, GetJobApplicationUsageStatisticsToJSON, } from './GetJobApplicationUsageStatistics.js';
import { SkillDtoFromJSON, SkillDtoToJSON, } from './SkillDto.js';
import { EducationExperienceDtoFromJSON, EducationExperienceDtoToJSON, } from './EducationExperienceDto.js';
import { WorkExperienceDtoFromJSON, WorkExperienceDtoToJSON, } from './WorkExperienceDto.js';
import { NullableRangeDtoFromJSON, NullableRangeDtoToJSON, } from './NullableRangeDto.js';
import { RangeDtoFromJSON, RangeDtoToJSON, } from './RangeDto.js';
/**
 * Check if a given object implements the GetJobApplicationAnonymousUser interface.
 */
export function instanceOfGetJobApplicationAnonymousUser(value) {
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('cityName' in value) || value['cityName'] === undefined)
        return false;
    if (!('searchLocationName' in value) || value['searchLocationName'] === undefined)
        return false;
    if (!('searchLocationRadius' in value) || value['searchLocationRadius'] === undefined)
        return false;
    if (!('isSearchEverywhere' in value) || value['isSearchEverywhere'] === undefined)
        return false;
    if (!('skills' in value) || value['skills'] === undefined)
        return false;
    if (!('topSkills' in value) || value['topSkills'] === undefined)
        return false;
    if (!('yearsExperience' in value) || value['yearsExperience'] === undefined)
        return false;
    if (!('hoursPerWeek' in value) || value['hoursPerWeek'] === undefined)
        return false;
    if (!('educationLevel' in value) || value['educationLevel'] === undefined)
        return false;
    if (!('personalCharacteristics' in value) || value['personalCharacteristics'] === undefined)
        return false;
    if (!('personalityTypeId' in value) || value['personalityTypeId'] === undefined)
        return false;
    if (!('educationExperiences' in value) || value['educationExperiences'] === undefined)
        return false;
    if (!('noEducationExperience' in value) || value['noEducationExperience'] === undefined)
        return false;
    if (!('workExperiences' in value) || value['workExperiences'] === undefined)
        return false;
    if (!('noWorkExperience' in value) || value['noWorkExperience'] === undefined)
        return false;
    if (!('workExperienceComplete' in value) || value['workExperienceComplete'] === undefined)
        return false;
    if (!('ambitions' in value) || value['ambitions'] === undefined)
        return false;
    if (!('personalInterests' in value) || value['personalInterests'] === undefined)
        return false;
    if (!('newJobReason' in value) || value['newJobReason'] === undefined)
        return false;
    if (!('isCompleteProfileRequestSent' in value) || value['isCompleteProfileRequestSent'] === undefined)
        return false;
    if (!('prefersContactOverPhone' in value) || value['prefersContactOverPhone'] === undefined)
        return false;
    if (!('allowPhoneCalls' in value) || value['allowPhoneCalls'] === undefined)
        return false;
    if (!('allowTexts' in value) || value['allowTexts'] === undefined)
        return false;
    if (!('usageStatistics' in value) || value['usageStatistics'] === undefined)
        return false;
    return true;
}
export function GetJobApplicationAnonymousUserFromJSON(json) {
    return GetJobApplicationAnonymousUserFromJSONTyped(json, false);
}
export function GetJobApplicationAnonymousUserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['userId'],
        'cityName': json['cityName'],
        'searchLocationName': json['searchLocationName'],
        'searchLocationRadius': json['searchLocationRadius'],
        'isSearchEverywhere': json['isSearchEverywhere'],
        'skills': (json['skills'].map(SkillDtoFromJSON)),
        'topSkills': (json['topSkills'].map(SkillDtoFromJSON)),
        'yearsExperience': NullableRangeDtoFromJSON(json['yearsExperience']),
        'hoursPerWeek': RangeDtoFromJSON(json['hoursPerWeek']),
        'educationLevel': json['educationLevel'],
        'personalCharacteristics': json['personalCharacteristics'],
        'personalityTypeId': json['personalityTypeId'],
        'educationExperiences': (json['educationExperiences'].map(EducationExperienceDtoFromJSON)),
        'noEducationExperience': json['noEducationExperience'],
        'workExperiences': (json['workExperiences'].map(WorkExperienceDtoFromJSON)),
        'noWorkExperience': json['noWorkExperience'],
        'workExperienceComplete': json['workExperienceComplete'],
        'ambitions': json['ambitions'],
        'personalInterests': json['personalInterests'],
        'newJobReason': json['newJobReason'],
        'isCompleteProfileRequestSent': json['isCompleteProfileRequestSent'],
        'prefersContactOverPhone': json['prefersContactOverPhone'],
        'allowPhoneCalls': json['allowPhoneCalls'],
        'allowTexts': json['allowTexts'],
        'usageStatistics': GetJobApplicationUsageStatisticsFromJSON(json['usageStatistics']),
    };
}
export function GetJobApplicationAnonymousUserToJSON(json) {
    return GetJobApplicationAnonymousUserToJSONTyped(json, false);
}
export function GetJobApplicationAnonymousUserToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'userId': value['userId'],
        'cityName': value['cityName'],
        'searchLocationName': value['searchLocationName'],
        'searchLocationRadius': value['searchLocationRadius'],
        'isSearchEverywhere': value['isSearchEverywhere'],
        'skills': (value['skills'].map(SkillDtoToJSON)),
        'topSkills': (value['topSkills'].map(SkillDtoToJSON)),
        'yearsExperience': NullableRangeDtoToJSON(value['yearsExperience']),
        'hoursPerWeek': RangeDtoToJSON(value['hoursPerWeek']),
        'educationLevel': value['educationLevel'],
        'personalCharacteristics': value['personalCharacteristics'],
        'personalityTypeId': value['personalityTypeId'],
        'educationExperiences': (value['educationExperiences'].map(EducationExperienceDtoToJSON)),
        'noEducationExperience': value['noEducationExperience'],
        'workExperiences': (value['workExperiences'].map(WorkExperienceDtoToJSON)),
        'noWorkExperience': value['noWorkExperience'],
        'workExperienceComplete': value['workExperienceComplete'],
        'ambitions': value['ambitions'],
        'personalInterests': value['personalInterests'],
        'newJobReason': value['newJobReason'],
        'isCompleteProfileRequestSent': value['isCompleteProfileRequestSent'],
        'prefersContactOverPhone': value['prefersContactOverPhone'],
        'allowPhoneCalls': value['allowPhoneCalls'],
        'allowTexts': value['allowTexts'],
        'usageStatistics': GetJobApplicationUsageStatisticsToJSON(value['usageStatistics']),
    };
}
